import { combineReducers } from 'redux'

const listInfo = (state = {isLoad: false, val: []}, action) => {
    switch (action.type) {
      case 'Informasi_modul':
        return {isLoad: action.load, val: action.val}
      default:
        return state
    }
}
const listInfoById = (state = {isLoad: false, val: []}, action) => {
  switch (action.type) {
    case 'Informasi_by_id_modul':
      return {isLoad: action.load, val: action.val}
    default:
      return state
  }
}

const modal = (state = false, action) => {
    switch (action.type) {
      case 'INFO_MODAL':
        return action.val
      default:
        return state
    }
}

const InfoReducer = combineReducers({
    listInfo,
    modal,
    listInfoById
  })
  
export default InfoReducer;